import { abbreviateNumber } from "helpers";
import { t } from "i18next";
import { Stat } from "ui";

import { StatisticCardProps } from "./StatisticCard.types";

import styles from "./StatisticCard.module.scss";

const StatisticCard = ({
  title,
  totalAmount = 0,
  comparablePeriodAmount = 0,
  isLoadingForCompare = false,
  isLoading,
  withComparativePeriod = true
}: StatisticCardProps) => {
  return (
    <div className={styles.statistic__card}>
      <Stat
        size="md"
        title={t(title)}
        amount={abbreviateNumber(totalAmount, 2)}
        isLoadingAmount={isLoading}
      />

      {withComparativePeriod && (
        <>
          <div className={styles["statistic__card--separator"]} />

          <Stat
            title={t("In comparable period")}
            amount={abbreviateNumber(comparablePeriodAmount, 2)}
            percentage={
              ((comparablePeriodAmount - totalAmount) / totalAmount) * 100
            }
            isLoadingAmount={isLoadingForCompare}
            className={styles["statistic__card--item"]}
          />
        </>
      )}
    </div>
  );
};

export default StatisticCard;
